import { createMutateReducer } from "common/helpers/reducer";
import * as action from "../actions/cpKkmListAction";

const initialState = {
	isLoading: true,
	isNoItems: false,

	scroll: {
		isLoading: false,
		size: 20,
		page: 0,
		totalElements: 0
	},
	search: {
		isLoading: false,
		value: ""
	},

	items: []
};
const actionHandlers = {
	// initialize
	[action.initCpKkmList.request]: createMutateReducer((draft, { tab, backgroundLoading }) => {
		draft.isLoading = !backgroundLoading; // фоновая загрузка при переключении табов
		draft.search.tab = tab;
		draft.scroll.page = 0;
	}),
	[action.initCpKkmList.success]: createMutateReducer((draft, { items, totalElements }) => {
		draft.isLoading = false;
		draft.isNoItems = !items.length;
		draft.scroll.totalElements = totalElements;
		draft.items = items;
	}),
	[action.initCpKkmList.error]: createMutateReducer(draft => {
		draft.isLoading = false;
	}),

	// infinite scroll
	[action.scrollCpKkmList.request]: createMutateReducer(draft => {
		draft.scroll.isLoading = true;
	}),
	[action.scrollCpKkmList.success]: (state, { items, page }) => {
		return {
			...state,
			scroll: {
				...state.scroll,
				isLoading: false,
				page
			},
			items: [...state.items, ...items]
		};
	},
	[action.scrollCpKkmList.error]: createMutateReducer(draft => {
		draft.scroll.isLoading = false;
	}),

	// search
	[action.searchCpKkmList.request]: createMutateReducer((draft, { value }) => {
		draft.search.isLoading = true;
		draft.search.isNoItems = false;
		draft.search.value = value;
	}),
	[action.searchCpKkmList.success]: createMutateReducer((draft, { items, totalElements }) => {
		draft.search.isLoading = false;
		draft.search.isNoItems = !items.length;
		draft.scroll.totalElements = totalElements;
		draft.scroll.page = 0;
		draft.items = items;
	}),
	[action.searchCpKkmList.error]: createMutateReducer(draft => {
		draft.search.isLoading = false;
	})
};

export { initialState, actionHandlers };
export default createReducer => createReducer(initialState, actionHandlers);
